<template>
<!--  <div>ssss</div>-->
  <div>
    <top-header></top-header>
    <div class="search_container">
      <div style="padding-top: 30px;padding-left: 30px">
        <span style="padding-right: 20px">搜索</span>
        <el-input v-model="searchValue" placeholder="请输入搜索内容" style="width: 200px; padding-right: 20px"/>
        <el-button type="primary" style="padding-left: 20px" @click="searchBtnClick">搜索</el-button>
      </div>
    </div>
    <el-button
      type="primary"
      icon="el-icon-plus" style="margin-top: 10px;margin-left: 20px"
      @click="handleAddTeacher">添加老师</el-button>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%">
        <el-table-column
          label="姓名"
          prop="Name">
        </el-table-column>
        <el-table-column
          label="联系方式"
          prop="Mobile">
        </el-table-column>
<!--        <el-table-column-->
<!--          label="状态">-->
<!--          <template slot-scope="props">-->
<!--            <p> {{ props.row.Status === 0 ? '禁用' : '正常' }}</p>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          label="更新时间">
          <template slot-scope="props">
            <p> {{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.UpdateTime) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleTeacherInfo(scope.$index, scope.row)">查看</el-button>
            <el-button
              size="mini"
              @click="handleModifyTeacher(scope.$index, scope.row)">修改</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="handleDeleteTeacher(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加老师" :visible.sync="dialogAddTeacherVisible">
      <el-form :model="addTeacherModel">
        <el-form-item label="姓名" label-width="100px">
          <el-input v-model="addTeacherModel.Name"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="100px">
          <el-input v-model="addTeacherModel.Passwd"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="100px">
          <el-input v-model="addTeacherModel.Mobile"></el-input>
        </el-form-item>
        <el-form-item label="昵称" label-width="100px">
          <el-input v-model="addTeacherModel.Nick"></el-input>
        </el-form-item>
        <el-form-item label="后台权限" label-width="100px">
          <user-premissions-component ref="addTeaPermissions"></user-premissions-component>
        </el-form-item>
      </el-form>
      <div style="padding-top: 10px;padding-left: 30px">
        <el-button @click="dialogAddTeacherVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTeacherOkBtnClick">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑老师" :visible.sync="dialogModifyTeacherVisible">
      <el-form :model="modifyTeacherModel">
        <el-form-item label="姓名" label-width="100px">
          <el-input v-model="modifyTeacherModel.Name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="100px">
          <el-input v-model="modifyTeacherModel.Mobile"></el-input>
        </el-form-item>
        <el-form-item label="后台权限" label-width="100px">
          <user-premissions-component ref="modifyTeaPermissions"></user-premissions-component>
        </el-form-item>
      </el-form>
      <div style="padding-top: 10px;padding-left: 30px">
        <el-button @click="dialogModifyTeacherVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyTeacherOkBtnClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
import UserPremissionsComponent from '../../components/user/UserPremissionsComponent'
export default {
  name: 'TeaManager',
  components: {UserPremissionsComponent, TopHeader},
  data () {
    return {
      dataList: [],
      currentPage: 1,
      pageCount: 10,
      totalCount: 0,
      dialogAddTeacherVisible: false,
      dialogModifyTeacherVisible: false,
      addTeacherModel: {},
      modifyTeacherModel: {},
      searchValue: ''
    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/teacherop') {
          console.log('----', route.path)
          that.getTeacherList()
        }
      },
      deep: true
    }
  },
  created () {
    this.getTeacherList()
  },
  methods: {
    getTeacherList () {
      if (this.searchValue === '') {
        let requestData = {count: this.pageCount, page: this.currentPage}
        this.$api.userManager.getTeacherList(requestData).then((res) => {
          if (res.code === 0) {
            this.dataList = res.data
            this.totalCount = res.count
          }
        })
      } else {
        let requestData = {count: this.pageCount, page: this.currentPage, key: this.searchValue}
        this.$api.userManager.searchTeacher(requestData).then((res) => {
          if (res.code === 0) {
            this.dataList = res.data
            this.totalCount = res.count
          }
        })
      }
    },
    searchBtnClick () {
      this.currentPage = 1
      this.getTeacherList()
    },
    handleSizeChange (val) {
      this.pageCount = val
      this.currentPage = 1
      this.getTeacherList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTeacherList()
    },
    handleAddTeacher () {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogAddTeacherVisible = true
      if (this.$refs.addTeaPermissions === null || this.$refs.addTeaPermissions === undefined) {
        let that = this
        setTimeout(function () {
          that.$refs.addTeaPermissions.setIsTeacher(true)
        }, 100)
      } else {
        this.$refs.addTeaPermissions.setIsTeacher(true)
      }
    },
    addTeacherOkBtnClick () {
      let permissions = this.$refs.addTeaPermissions.getCurPremissions()
      let permissionsStr = JSON.stringify(permissions)
      let requestData = {name: this.addTeacherModel.Name, mobile: this.addTeacherModel.Mobile, passwd: this.addTeacherModel.Passwd, userop: permissionsStr, nick: this.addTeacherModel.Nick}
      this.$api.userManager.addTeacher(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.addTeacherModel = {}
          this.getTeacherList()
          this.dialogAddTeacherVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleTeacherInfo (index, row) {
      this.$router.push({path: '/teacherInfo', query: {teacherId: row.Id}})
    },
    handleModifyTeacher (index, row) {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogModifyTeacherVisible = true
      this.modifyTeacherModel = row
      if (this.modifyTeacherModel.UserOp === null || this.modifyTeacherModel.UserOp === undefined) {
        this.modifyTeacherModel.UserOp = '[]'
      }
      let permissionArray = JSON.parse(this.modifyTeacherModel.UserOp)
      let that = this
      setTimeout(function () {
        that.$refs.modifyTeaPermissions.setIsTeacher(true)
        that.$refs.modifyTeaPermissions.setCurPremissions(permissionArray)
      }, 100)
    },
    modifyTeacherOkBtnClick () {
      let permissions = this.$refs.modifyTeaPermissions.getCurPremissions()
      let permissionsStr = JSON.stringify(permissions)
      let requestData = {id: this.modifyTeacherModel.Id, mobile: this.modifyTeacherModel.Mobile, name: this.modifyTeacherModel.Name, userop: permissionsStr}
      this.$api.userManager.modifyTeacher(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getTeacherList()
          this.dialogModifyTeacherVisible = false
        }
      })
    },
    handleDeleteTeacher (index, row) {
      let alertStr = '确定要删除老师   "' + row.Name + '"   吗？'
      this.$confirm(alertStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {id: row.Id}
        this.$api.userManager.delTeacher(requestData).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getTeacherList()
          }
        })
      }).catch(() => {

      })
    },
    formatDate (fmt, dateStr) {
      let date = new Date(dateStr)
      let ret
      let opt = {
        'Y+': date.getFullYear().toString(),
        'm+': (date.getMonth() + 1).toString(),
        'd+': date.getDate().toString(),
        'H+': date.getHours().toString(),
        'M+': date.getMinutes().toString(),
        'S+': date.getSeconds().toString()
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
      };
      return fmt
    }
  }
}
</script>

<style scoped>
  .search_container{
    margin: 20px;
    height: 100px;
    background-color: #EFF1F6;
  }
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/userManager/TeaManager.vue